import React, { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts'
import baseServices from '../../../services/base.services'

const LineAPC = ({ body, height, name, color }) => {
    const [state, setState] = useState(null)

    // Line
    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getDataTostacionDMH2(body)
                if (response.data && response.data.length > 0) {
                    let arrayValor1 = []
                    let arrayValor2 = []

                    response.data.forEach((x, i) => {
                        arrayValor1.push(x.Hora)
                        arrayValor2.push(x.Valor)
                    })

                    setState({
                        valor1: arrayValor1,
                        valor2: arrayValor2
                    })
                    setTimeout(() => { getTTeg() }, 60000)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {
                state ?
                    <Chart
                        animation={true}
                        height={height}
                    // subtitle='Hola'
                    >
                        <Chart.Line
                            showInLegend={false}
                            name={name}
                            marker={{
                                enabled: false
                            }}
                            data={state.valor2}
                            color={color}
                        />

                        <Chart.XAxis
                            categories={state.valor1}
                        />
                        <Chart.YAxis
                            gridLineWidth='0'
                        />
                    </Chart>
                    :
                    <div className='letter-origin'>...No hay datos</div>
            }

        </>
    )
}

export default LineAPC